<div class="container-fluid navBarInvoice">
  <app-header-form
    [title]="title"
    [panelOpenState]="panelOpenState"
    [canShowClearFilter]="true"
    [canShowPanelFilter]="true"
    [canExportExcel]="true"
    (onClearFilterEvent)="clearSearchFilter()"
    (onPanelOpenStateEvent)="onShowFilter($event)"
    (onExportAsExcelEvent)="exportAsExcel()"
    >
  </app-header-form>
</div>

<hr *ngIf="!panelOpenState">

<div class="container-fluid search-container">
  <div class="card" *ngIf="panelOpenState">
    <div class="card-body searchCard">
      <div fxLayout="row" fxLayoutGap="10px" >
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Prise en charge</mat-label>
              <ng-multiselect-dropdown [settings]="singleSelectionWithoutSearchDropdownSettings"
                  [data]="isPickedDropdownList" (onDeSelect)="onItemSelect()"
                  (onSelect)="onItemSelect()" placeholder='Sélectionner...' (onDeSelectAll)="onSelectAll($event)"
                  (onSelectAll)="onSelectAll($event)" [(ngModel)]="isPickedSelectedItems" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="30" fxLayoutAlign="start" >
          <div fxLayout="row" class="dateStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Date de r&eacute;ception</mat-label>
              <custom-date-range-input
              (onDateChange)="dateChangeSearch($event);"
              typeFrom="FromReceptionDate"
              [valueFrom]="importMissingInvoiceNumberDocumentSearchCriteriaModel.FromReceptionDate"
              typeTo="ToReceptionDate"
              [valueTo]="importMissingInvoiceNumberDocumentSearchCriteriaModel.ToReceptionDate"></custom-date-range-input>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="search-result">
    <app-table [(data)]="data"
        [tableActions]="tableActions"
        [tableIndications]="tableIndications"
        (onRowSelectionChange)="onRowSelectionChange($event)"
        (onAllRowSelectionChange)="onAllRowSelectionChange($event)"
        [columnsDefinition]="displayedColumnsLabel"
        [pageSize]="pageSize"
        [length]="paginatorLength"
        [configKey]="configKey"
        [highlights]="highlights"
        [onExport]="onExport"
        (onSortChange)="onSortChange($event)"
        [serverPagination]="true"
        [onExportDataSourceAvailable]="onExportDataSourceAvailable"
        (onPageChange)="onPageChange($event)"
        [onDataSourceChanged]="onDataSourceChanged"
        [exportFileName]="exportFileName"
        [onExportExcelCaller]="onExportExcelCaller"
        [onFiltersCleared]="onFiltersCleared"
        ngDefaultControl>

        <div class="row col" *ngIf="isAllSelected && paginatorLength > pageSize">
            <div class="alert alert-warning">Vous avez selectionné la totalité des <strong>{{paginatorLength}}</strong>
                documents.</div>
        </div>

        <div class="row col" mass-actions>
            <div *ngIf="selectedIds?.length > 0">
                <button type="button" class="btn btn-secondary btn-sm" tooltip="Télécharger les documents"
                    (click)="onMassDownload()">
                    <span class="material-icons">cloud_download</span>
                </button>
            </div>
            <div *ngFor="let massAction of tableMassActions" class="massaction-button">
                <div *ngIf="selectedIds?.length > 0 && massAction.Filter(selectedIds)">
                    <button type="button" class="btn btn-secondary btn-sm" (click)="massAction.Handler(selectedIds)">
                        <span class="material-icons" [tooltip]="massAction.Tooltip">{{massAction.Icon}}</span>
                    </button>
                </div>
            </div>
        </div>
    </app-table>
</div>
